import { callApi } from './api';

import { SupportPlanRequest } from '@/types/supportPlan';

export const createSupportPlan = async (requestBody: SupportPlanRequest) => {
  const { status, result } = await callApi<boolean>(
    'support-plans',
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
